import { Line } from "react-chartjs-2";
import classes from "./RlineChartForBranches.module.css";
import { LineChartForAllBranches } from "../../util/adminDashboard/lineChartForBranches";
export default function RlineChartForBranches({ data }) {
  const d1 = LineChartForAllBranches(data);

  if (d1 == null) return;
  return (
    <>
      <div className={classes.chartContainer}>
        <Line data={d1} />
      </div>
    </>
  );
}
